module.exports = __webpack_public_path__ + "static/vaunet-32f55140868c92ef5a00745be5cb72c7.svg";